export const getActiveGroups = () => {
  const activeGroupStr = window?.OnetrustActiveGroups;
  if (activeGroupStr) {
    return activeGroupStr.split(',').filter((str) => !!str);
  }
  return [];
};
export const getCategoryList = () => {
  // only categories with cookies associated are relevant
  const groups = window?.OneTrust?.GetDomainData().Groups || [];
  return groups
    .filter((group) => !!group.Cookies.length)
    .map((group) => group.CustomGroupId);
};

export const removeCookies = (categoryList, activeGroups) => {
  const categoriesToDelete = categoryList.filter((category) => !activeGroups.includes(category));
  const groupsToDelete = window?.OneTrust?.GetDomainData()?.Groups.filter(
    (group) => categoriesToDelete.includes(group.CustomGroupId),
  );
  groupsToDelete.forEach((group) => {
    group.Cookies.forEach((cookie) => {
      eraseCookie(cookie.Name);
    });
  });
};

const eraseCookie = (name) => {
  const domainName = window.location.hostname;
  document.cookie = `${name}=; Max-Age=-99999999; Path=/;Domain=${domainName}`;
  document.cookie = `${name}=; Max-Age=-99999999; Path=/;`;
  const my_domains = [
    'www.themobileshop.ca',
    '.themobileshop.ca',
    'www.laboutiquemobile.ca',
    '.laboutiquemobile.ca',
    'www.uat.themobileshop.ca',
    '.uat.themobileshop.ca',
    '.bat.bing.com',
    '.bing.com',
    '.facebook.com',
    'www.google.com',
    '.google.com',
    '.www.google-analytics.com',
    '.analytics.google.com',
    '.mookie1.com',
    '.pinterest.com',
    '.ct.pinterest.com',
    '.snapchat.com',
    '.t.co',
    '.tiktok.com',
    '.twitter.com',
    '.youtube.com',
    'sc-static.net',
    '.doubleclick.net',
    '.everesttech.net',
  ];
  for (let k = 0; k < my_domains.length; k++) {
    document.cookie = `${name}=; Max-Age=-99999999; Path=/;Domain=${my_domains[k]}`;
  }
  localStorage.removeItem(name);
  const pathArray = window.location.pathname.split("/");
  for (let i = 0; i < pathArray.length; i++) {
    if (pathArray[i]) {
      const currentPath = pathArray.slice(0, i + 1).join("/");
      document.cookie = `${name}=; Max-Age=-99999999; Path=${currentPath};Domain=${domainName}`;
      document.cookie = `${name}=; Max-Age=-99999999; Path=${currentPath};`;
      document.cookie = `${name}=; Max-Age=-99999999; Path=${currentPath}/;Domain=${domainName}`;
      document.cookie = `${name}=; Max-Age=-99999999; Path=${currentPath}/;`;
    }
  }
};
